import { request } from '@/shared/api/request'

export const getContracts = (params, cache = false) => {
	return request({ url: 'colcontract/page', method: 'POST', params: params, cache: cache })
}
